<script setup>
import { ref, onMounted } from 'vue';
import { Link } from '@inertiajs/vue3';
import CookieService from '@/Services/CookieService';

defineOptions({
  inheritAttrs: false,
});

const show = ref(false);

onMounted(() => {
    show.value = !CookieService.hasConsent();

    window.addEventListener('close-cookie-popup', () => {
        show.value = false;
    });
});

const acceptAll = () => {
    const preferences = {
        necessary: true,
        functional: true,
        analytics: true,
        marketing: true
    };
    CookieService.saveCookiePreferences(preferences);
    show.value = false;
};

const acceptNecessaryOnly = () => {
    const preferences = {
        necessary: true,
        functional: false,
        analytics: false,
        marketing: false
    };
    CookieService.saveCookiePreferences(preferences);
    show.value = false;
};
</script>

<template>
  <div v-if="show" v-bind="$attrs" class="cookie-consent-wrapper">
    <div class="cookie-banner">
      <div class="cookie-content">
        <h5>Vi bruger cookies</h5>
        <p>
          Denne hjemmeside bruger cookies til at forbedre din oplevelse.
          Du kan vælge hvilke cookies du vil tillade.
        </p>

        <div class="cookie-actions">
          <!--
              Sitets egne knapper, ikke Bootstraps blaa. Banneret er det
              foerste enhver besoegende ser, og det stod i en farve der ikke
              findes noget andet sted paa sitet.
          -->
          <button @click="acceptAll" class="btn btn-pricecompare-primary btn-sm">Accepter alle</button>
          <button @click="acceptNecessaryOnly" class="btn btn-pricecompare-outline btn-sm mx-2">Kun nødvendige</button>
          <Link as="button" :href="route('cookie.preferences')" class="btn btn-link btn-sm">
            Tilpas indstillinger
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cookie-consent-wrapper {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  z-index: 9999;
}

/*
 * BANNERET VAR HARDKODET HVIDT, og knappen forsvandt i det moerke tema.
 *
 * MAALT 16. oktober 2026 paa alle fjorten bredder: "Kun noedvendige" stod
 * paa 1,9:1. Knappen bruger `color: var(--pc-accent)`, og accenten SKIFTER
 * med temaet — #06D6A0 er en lys groen beregnet til moerk baggrund, og den
 * laa her paa hvid. I det lyse tema er accenten #059669 og alt var fint, saa
 * fejlen var usynlig for den der kun saa ét tema.
 *
 * Det er det foerste fund fra kontrastmaalingen i tests/e2e/responsiv.mjs.
 */
.cookie-banner {
  background-color: var(--pc-bg-secondary);
  color: var(--pc-text-primary);
  border: 1px solid var(--pc-border);
  border-radius: 8px;
  box-shadow: var(--pc-shadow-lg);
  padding: 1.25rem;
  max-width: 500px;
  margin: 0 auto;
}

.cookie-content h5 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.cookie-content p {
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

/*
 * `color: black` hoerte til dengang banneret var hvidt.
 *
 * Da baggrunden begyndte at foelge temaet, blev sort tekst paa moerk flade:
 * 1,1:1 paa alle fjorten bredder. Foerste rettelse flyttede altsaa fejlen i
 * stedet for at loese den — overskriften og broedteksten havde deres egen
 * farve, og den fulgte ikke med.
 *
 * Fanget af kontrastmaalingen i tests/e2e/responsiv.mjs, ikke af et oeje.
 */
.cookie-content h5,
.cookie-content p {
  color: var(--pc-text-primary);
}

.cookie-actions {
  display: flex;
  align-items: center;
}

@media (max-width: 576px) {
  .cookie-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-actions button {
    margin: 0.25rem 0;
  }
}
</style>
